import { render, staticRenderFns } from "./COL.vue?vue&type=template&id=c196ca92&scoped=true&"
import script from "./COL.vue?vue&type=script&lang=js&"
export * from "./COL.vue?vue&type=script&lang=js&"
import style0 from "./COL.vue?vue&type=style&index=0&id=c196ca92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c196ca92",
  null
  
)

export default component.exports